



























import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import useProductPage from '~/composables/useProductPage'
import { SfIcon } from '@storefront-ui/vue';
export default defineComponent({
    components:{
        SfIcon
    },
    props:{
        classes: {
            type:  Object as PropType<{root : String}>,
            default: ()=>{return {root:''}}
        }
    },
    setup() {
        const { product } = useProductPage();
        return {
            hasOptionalModules: product.value.modules.length>0,
            requiredModules : product.value.requiredModules,
            hasDigitalSole24H: product.value.hasDigitalSole24H
        }
    },
})
